package io.github.kingsword09.symbolcraft.symbols.icons.`simple-icons`.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.`simple-icons`.Icons

public val Icons.PlaystationvitaSimpleIcons: ImageVector
    get() {
        if (_playstationvitaSimpleIcons != null) {
            return _playstationvitaSimpleIcons!!
        }
        _playstationvitaSimpleIcons = Builder(name = "PlaystationvitaSimpleIcons", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 24.0f, viewportHeight = 24.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(3.18f, 12.22f)
                lineTo(1.27f, 12.22f)
                curveToRelative(-0.26f, 0.0f, -0.45f, 0.20f, -0.45f, 0.54f)
                verticalLineToRelative(1.24f)
                lineTo(0.0f, 13.99f)
                verticalLineToRelative(-1.19f)
                curveToRelative(0.0f, -0.67f, 0.42f, -1.12f, 1.01f, -1.12f)
                horizontalLineToRelative(1.92f)
                curveToRelative(0.47f, -0.02f, 0.58f, -0.25f, 0.58f, -0.59f)
                curveToRelative(0.0f, -0.26f, -0.13f, -0.62f, -0.58f, -0.58f)
                lineTo(0.0f, 10.51f)
                verticalLineToRelative(-0.49f)
                horizontalLineToRelative(3.18f)
                curveToRelative(0.83f, 0.0f, 1.16f, 0.48f, 1.16f, 1.07f)
                curveToRelative(0.0f, 0.67f, -0.33f, 1.13f, -1.16f, 1.13f)
                close()
                moveTo(6.66f, 11.09f)
                verticalLineToRelative(1.81f)
                curveToRelative(0.0f, 0.66f, -0.30f, 1.08f, -1.13f, 1.08f)
                lineTo(3.76f, 13.98f)
                verticalLineToRelative(-0.49f)
                horizontalLineToRelative(1.55f)
                curveToRelative(0.32f, 0.0f, 0.51f, -0.26f, 0.51f, -0.59f)
                verticalLineToRelative(-1.81f)
                curveToRelative(0.0f, -0.58f, 0.28f, -1.08f, 1.10f, -1.08f)
                horizontalLineToRelative(1.77f)
                verticalLineToRelative(0.49f)
                lineTo(7.16f, 10.51f)
                curveToRelative(-0.41f, -0.02f, -0.49f, 0.32f, -0.49f, 0.59f)
                close()
                moveTo(11.50f, 14.00f)
                curveToRelative(-0.33f, -0.02f, -0.47f, -0.27f, -0.53f, -0.38f)
                curveToRelative(-0.06f, -0.11f, -1.92f, -3.61f, -1.92f, -3.61f)
                horizontalLineToRelative(0.92f)
                lineToRelative(1.54f, 2.86f)
                curveToRelative(0.08f, 0.16f, 0.26f, 0.2f, 0.36f, 0.01f)
                lineToRelative(1.53f, -2.87f)
                horizontalLineToRelative(0.58f)
                reflectiveCurveToRelative(-1.80f, 3.40f, -1.87f, 3.52f)
                curveToRelative(-0.07f, 0.12f, -0.28f, 0.48f, -0.61f, 0.47f)
                close()
                moveTo(14.51f, 10.03f)
                horizontalLineToRelative(0.84f)
                verticalLineToRelative(3.96f)
                horizontalLineToRelative(-0.84f)
                close()
                moveTo(18.28f, 10.49f)
                lineToRelative(0.00f, 3.48f)
                horizontalLineToRelative(-0.83f)
                lineTo(17.46f, 10.49f)
                lineToRelative(-1.57f, -0.00f)
                verticalLineToRelative(-0.48f)
                lineTo(19.86f, 10.0f)
                lineToRelative(-0.00f, 0.49f)
                close()
                moveTo(21.51f, 10.01f)
                curveToRelative(-0.31f, 0.01f, -0.51f, 0.35f, -0.58f, 0.47f)
                curveToRelative(-0.07f, 0.12f, -1.87f, 3.53f, -1.87f, 3.53f)
                horizontalLineToRelative(0.58f)
                lineToRelative(0.44f, -0.84f)
                horizontalLineToRelative(2.54f)
                lineToRelative(0.45f, 0.84f)
                lineTo(24.0f, 14.00f)
                reflectiveCurveToRelative(-1.86f, -3.51f, -1.92f, -3.62f)
                curveToRelative(-0.06f, -0.11f, -0.20f, -0.36f, -0.53f, -0.38f)
                horizontalLineToRelative(-0.03f)
                close()
                moveTo(21.33f, 11.00f)
                curveToRelative(0.08f, -0.01f, 0.16f, 0.05f, 0.2f, 0.14f)
                lineToRelative(0.83f, 1.53f)
                horizontalLineToRelative(-2.00f)
                lineToRelative(0.82f, -1.54f)
                curveToRelative(0.04f, -0.08f, 0.10f, -0.12f, 0.16f, -0.13f)
                close()
            }
        }
        .build()
        return _playstationvitaSimpleIcons!!
    }

private var _playstationvitaSimpleIcons: ImageVector? = null
